import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { tap } from "rxjs/operators";
import { AuthService } from "../service/auth.service";

@Injectable({
    providedIn: "root"
})
export class AuthorizedGuard implements CanActivate {
    constructor(private authService: AuthService, public router: Router) {}

    canActivate(): boolean {
        if (!this.authService.isAuthenticated()) {
            this.authService
                .logout()
                .pipe(tap(() => this.router.navigate(["/"])))
                .subscribe();
            return false;
        }

        return true;
    }
}
